import React, { useEffect, useState } from 'react';
import { TextField, Button, Typography, Box, Paper, CircularProgress, List, ListItem, ListItemText } from '@mui/material';

const TemplateGenerator = () => {
  const [template, setTemplate] = useState([]);
  const [prompt, setPrompt] = useState('');
  const [history, setHistory] = useState([]);
  const [currentFilename, setCurrentFilename] = useState('');
   const [templateFilename, setTemplateFilename] = useState('');
  const [iframeSrc, setIframeSrc] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL;


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!prompt) return;

    setIsLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/templategenerator/generate_segment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt, history })
      });
      const { segment, filename } = await res.json();

      const newSegment = { prompt, segment, filename };
      setTemplate([...template, segment]);
      setHistory([...history, newSegment]);
      setCurrentFilename(filename);
      const newSrc = `${API_BASE_URL}/html/${filename}?t=${Date.now()}`;
      setIframeSrc(newSrc);
      setPrompt('');
      console.log(`Saved as ${filename}`);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
 useEffect(() => {
  setPrompt('Need a header with company logo(https://www.ivldsp.com/wp-content/uploads/2019/12/SAP-Addons-India-2.png) and Product logo(https://www.ivldsp.com/wp-content/uploads/2019/06/optigst-2.png) and body as {{main_mail_content}} and footer with copyright text "© 2025 IVLDSP. All rights reserved."');
  setTemplateFilename(`template_${Date.now()}.html`);
 }, []);
  // const cumulativeTemplate = template.join('\n\n');

  const handleSaveTemplate = async () => {
    if (!currentFilename || history.length === 0) return;
    const html = history[history.length - 1].segment;
    try {
      await fetch(`${API_BASE_URL}/templategenerator/savetemplate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: templateFilename, content: html })
      });
      console.log('Template saved');
      alert('Template saved successfully!');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box sx={{ display: 'flex', height: '95vh' }}>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: 1, borderColor: 'divider' }}>
        <Paper sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
          <Typography variant="h6" gutterBottom>History</Typography>
          <List>
            {history.map((item, index) => (
              <ListItem key={index}>
                <ListItemText primary={item.prompt} />
              </ListItem>
            ))}
          </List>
        </Paper>
        <Box sx={{ p: 3, borderTop: 1, borderColor: 'divider' }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 2,alignItems: 'center', }}>
            <TextField
              multiline
              rows={2}
              fullWidth
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder="Enter prompt"
              disabled={isLoading}
            />
            <Button
              type="submit"
              variant="contained"
              style={{ height: '40px' }}
              disabled={isLoading}
              startIcon={isLoading ? <CircularProgress size={20} /> : null}
            >
              {isLoading ? 'Generating...' : 'Generate'}
            </Button>
          </form>
        </Box>
      </Box>
      <Paper sx={{ flex: 1, p: 2, overflow: 'hidden' }}>
        <Typography variant="h6" gutterBottom>Generated Template Preview</Typography>
       
       {iframeSrc && (
        <Box sx={{ mb: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
          <iframe
            src={iframeSrc}
            style={{ width: '100%', height: 'calc(100% - 80px)', border: '1px solid #ccc' }}
            title="Email Template Preview"
          />
       
         <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
          <TextField
            size="small"
            value={templateFilename}
            label="Filename"
            onChange={(e) => setTemplateFilename(e.target.value)}           
            sx={{ flex: 1 }}
          />
          <Button variant="outlined" onClick={handleSaveTemplate}>
            Save Template
          </Button>
        </Box>
        </Box>
         )}
      </Paper>
    </Box>
  );
};

export default TemplateGenerator;